import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { OrdemServico } from '../../types/logistica';
import { ordensServicoService } from '../../services';

const columns: ResourceColumn<OrdemServico>[] = [
  { header: "Veículo", accessor: "veiculo_display" },
  { header: "Tipo", accessor: "tipo_servico" },
  { header: "Prioridade", accessor: "prioridade" },
  { header: "Status", accessor: "status" },
  { header: "Data Início", accessor: "data_inicio" },
  { header: "Custo Real", accessor: "custo_real" },
];

export const OrdensServicoListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Ordens de Serviço"
      description="Gerenciamento de ordens de serviço e manutenção de veículos."
      columns={columns}
      service={ordensServicoService}
      createPath="/admin/logistica/ordens-servico/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/ordens-servico/${item.id}`)}
    />
  );
};
